'use client';

import { useState, useEffect } from 'react';
import { Link } from '@/i18n/routing';
import { ShoppingCart } from 'lucide-react';
import { useCartStore } from '@/store/cart-store';
import { useLocale } from 'next-intl';
import { cartPath } from '@/lib/localized-paths';

export function CartButton() {
  const locale = useLocale();
  const getTotalItems = useCartStore((state) => state.getTotalItems);
  const [totalItems, setTotalItems] = useState(0);
  const [mounted, setMounted] = useState(false);

  // Wait for client-side hydration to avoid mismatch
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- standaard hydration-mount-detectie; er is geen ander moment om dit te weten dan in een effect
    setMounted(true);
    setTotalItems(getTotalItems());
  }, [getTotalItems]);

  // Subscribe to cart changes
  useEffect(() => {
    if (!mounted) return;

    const unsubscribe = useCartStore.subscribe(() => {
      setTotalItems(getTotalItems());
    });

    return unsubscribe;
  }, [mounted, getTotalItems]);

  return (
    <Link
      href={cartPath(locale)}
      className="flex items-center justify-center h-10 w-10 rounded-full hover:bg-gray-100 transition-colors relative"
      aria-label={locale === 'de' ? 'Warenkorb' : locale === 'fr' ? 'Panier' : locale === 'en' ? 'Cart' : 'Winkelwagen'}
    >
      <ShoppingCart className="h-5 w-5 text-gray-600" />
      {mounted && totalItems > 0 && (
        <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-blue-600 text-xs font-medium text-white flex items-center justify-center">
          {totalItems > 99 ? '99+' : totalItems}
        </span>
      )}
    </Link>
  );
}
